export default {
    // ----------Title----------
    reports: 'รายงาน',
    containersReport: 'รายงานภาชนะ',
    productsReport: 'รายงานสินค้า',
    productItemsReport: 'รายงานรายการสินค้า',
    selectLocations: 'เลือกสถานที่',
    scopeTheRangeOfTheSearchLocations: 'กำหนดขอบเขตพื้นที่การค้นหา',
    dataFilters: 'ตัวกรองข้อมูล',
    multipleFiltersApplyToDatasetResults: 'การใช้ตัวกรองหลายตัวกับผลลัพธ์ชุดข้อมูล',
    selectSearchLocation: 'เลือกสถานที่ค้นหา',
    youCanSelectMultipleWarehouseLocationsToProceed: 'คุณสามารถเลือกหลายคลังสินค้าเพื่อดำเนินการต่อ',

    exportAllToExcel: `ส่งออกทั้งหมดเป็นไฟล์ Excel`,

    // ----------Drawer---------
    advancedFilters: 'ตัวกรองขั้นสูง',

    // -----------MUI----------
    createDateFrom: 'วันที่สร้างตั้งแต่',
    createDateTo: 'วันที่สร้างถึง',
    checkedInAtFrom: 'วันที่เช็คอินตั้งแต่',
    checkedInAtTo: 'วันที่เช็คอินถึง',
    loadDateFrom: 'วันที่โหลดตั้งแต่',
    loadDateTo: 'วันที่โหลดถึง',
    startQuery: 'เริ่มการค้นหา',
    customerMarking: 'สัญลักษณ์ลูกค้า',
    supplierName: 'ชื่อผู้จัดส่ง',
    supplierContact: 'ผู้ติดต่อผู้จัดส่ง',
    supplierPNo: 'หมายเลขผู้จัดส่ง(PNo)',
    applyFilters: 'ใช้ตัวกรอง',
    companyPNo: 'หมายเลขบริษัท',
    courierNo: 'หมายเลขขนส่ง',
    containerId: 'คอนเทนเนอร์ ID',
    signedBy: 'ลงนามโดย',
    createdDateTime: 'วันที่และเวลาที่สร้าง',
    loadStatus: 'สถานะการโหลด',
    containerNo: 'หมายเลขภาชนะ',
    id: 'ID',
    depositFee: 'ค่ามัดจำ',
    transportFee: 'ค่าขนส่ง',

    location: 'สถานที่',
    toLocation: 'ไปยังสถานที่',
    containerMarking: 'สัญลักษณ์ภาชนะ',
    createdBy: 'สร้างโดย',
}